import React from 'react'
import styles from './_cardTitle.scss'
import PropTypes from 'prop-types'

const CardTitle = ({ title, subtitle }) => {
  return (
    <header className={styles.cardTitle}>
      <div className={[styles.cardTitleContent, 'px-5', 'py-4'].join(' ')}>
        {typeof title === 'string' ? <h1>{title}</h1> : { title }}
        {typeof subtitle === 'string' ? <h2>{subtitle}</h2> : { subtitle }}
      </div>
    </header>
  )
}

CardTitle.defaultProps = {
  title: '',
  subtitle: ''
}

CardTitle.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
}

export default CardTitle
